export default __webpack_public_path__ + "assets/images/merry-christmas_3oN2-.jpg";